import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';
import { z } from 'zod';

// Import existing types to use in function signatures
import { EmploymentSchedule } from '../../types/backendResponses/EmploymentSchedule';
import {
  UpdateEmploymentScheduleRequestSchema,
  EmploymentScheduleSchema,
} from '../schemas/employmentScheduleSchemas';

/**
 * Hook for updating an employment schedule with built-in state management
 * Includes Zod validation for type safety
 */
export const useUpdateEmploymentSchedule = () => {
  const { callAPI } = useAPI({ method: 'PUT' });

  const [data, setData] = useState<EmploymentSchedule | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Update an employment schedule
   * @param scheduleData - The schedule data to update
   * @returns Promise with boolean indicating success
   */
  const action = async (scheduleData: any): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      // Validate the request data
      const validatedRequest =
        /* UpdateEmploymentScheduleRequestSchema.parse( */ scheduleData; /* ) */

      const response = await callAPI(buildApiUrl('employmentSchedule'), validatedRequest);

      // Validate the response data
      const validatedResponse =
        /* EmploymentScheduleSchema.parse( */ response /* ) */ as EmploymentSchedule;

      setData(validatedResponse as EmploymentSchedule);
      return true;
    } catch (error) {
      console.error('Error in useUpdateEmploymentSchedule:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    error,
    action,
  };
};
